module.exports = __webpack_public_path__ + "img/banner2.87bcfec6.jpg";